import { Component, OnInit, HostListener, ViewChild, ElementRef, Inject, Directive } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SeoService } from '../../services/seo.service';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';

import { IParallaxScrollConfig } from 'ngx-parallax-scroll';
import AOS from "aos";
declare var pannellum: any;

@Component({
  selector: 'app-wold-as-one',
  templateUrl: './wold-as-one.component.html',
  styleUrls: ['./wold-as-one.component.scss']
})

export class WoldAsOneComponent implements OnInit {

  pdfSrc = './assets/docs/Seed-Group-onboards-Gennius-XYZ-to-transform-the-digital-asset-ecosystem-in-MENA.pdf'

  images=[
    './assets/img/gennius/agreement2.webp',
    './assets/img/gennius/agreement6.webp',
    './assets/img/gennius/agreement4.webp',
    './assets/img/gennius/agreement3.webp',
    './assets/img/gennius/agreement5.webp',

  ]

  hash: any;
  public video1: boolean;
  public video2: boolean;
  public video3: boolean;
  public video4: boolean;
  public video5: boolean;
  public video6: boolean;
  public video7: boolean;
  public video8: boolean;
  public video9: boolean;
  public video10: boolean;
  public video11: boolean;
  public video12: boolean;
  public video13: boolean;
  public video14: boolean;

  public show:boolean;
  public play1:boolean;
  public play2:boolean;
  public play3:boolean;
  public play4:boolean;
  public play5:boolean;
  public play6:boolean;

  public register:boolean;
  public sole:boolean;
  public receivedMessage:any;
  public storage:boolean;

  ngParallaxConf: IParallaxScrollConfig = {
    parallaxSpeed: 1,
    parallaxSmoothness: 1,
    parallaxDirection: 'reverse',
    parallaxTimingFunction: 'ease-in',
    parallaxThrottleTime: 80
  };

  public fixed:boolean;
  public scroll:boolean;
  public itsMobile = false;

  constructor(private el: ElementRef, @Inject(DOCUMENT) private document: any,private title: Title, private seo: SeoService) {
    this.hash = window.location.hash;

    let messageReceived = false;

     // EVENTO QUE CAPTURA EL POSTMESSAGE
    window.addEventListener('message', (event) => {
      // if (event.origin === 'https://gennius.xyz') {
        const message = event.data;
        this.receivedMessage = message;
        console.log('Mensaje recibido del iframe:', message);
        if(message=='crearBoton'){
          this.receivedMessage = true;
          localStorage.setItem('registrado', this.receivedMessage);
          this.soleOne();
          setTimeout(() => {
            this.register = false;
          }, 1000);

        }
      // }
    });

  }

  /* @HostListener('body:scroll', ['$event'])
  onScrollingEvent($event): void {
     let scrollOffset = $event.target.scrollTop;
     console.log(scrollOffset)

  } */

  @HostListener('window:scroll', [])
  // onWindowScroll() {
  //   const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  //   const image = this.el.nativeElement.querySelector('.img-cymi');

  //   const logOne = this.el.nativeElement.querySelectorAll('.logo-cymi-aos');
  //   const logoCymi = this.el.nativeElement.querySelector('.al');

  //   const sectionVideo = this.el.nativeElement.querySelectorAll('.video-play');

  //   for (var val of logOne) {
  //     if(val.classList.contains('four') || val.classList.contains('five')){
  //       if(offset >= val.offsetTop - 500){
  //         val.classList.add('animate');
  //       }else{
  //         val.classList.remove('animate');
  //       }
  //     }else{
  //       if(offset >= val.offsetTop - 400){
  //         val.classList.add('animate');
  //       }else{
  //         val.classList.remove('animate');
  //       }
  //     }

  //   }

  //   if(offset == 0){
  //     image.style.transform = 'translateY(0)';
  //     image.style.opacity = '1';
  //   }

  //   if(offset >= logoCymi.offsetTop - 300){
  //     logoCymi.classList.add('animate');
  //   }else{
  //     logoCymi.classList.remove('animate');
  //   }

  //   for (var val of sectionVideo) {
  //     if(offset >= val.offsetTop - 300){

  //       if(val.className == 'first-child video-play'){
  //         const video = this.el.nativeElement.querySelector('.first-child .right video');
  //         video.play();
  //       }else if(val.className == 'fund-middle second video-play'){
  //         const video = this.el.nativeElement.querySelector('.second .left video');
  //         video.play();
  //       }else if(val.className == 'third video-play'){
  //         const video = this.el.nativeElement.querySelector('.third .right video');
  //         video.play();
  //       }else if(val.className == 'fund-middle fourth video-play'){
  //         const video = this.el.nativeElement.querySelector('.fourth .left video');
  //         video.play();
  //       }else if(val.className == 'fifth video-play'){
  //         const video = this.el.nativeElement.querySelector('.fifth .right video');
  //         video.play();
  //       }else if(val.className == 'fund-middle sixth video-play'){
  //         const video = this.el.nativeElement.querySelector('.sixth .left video');
  //         video.play();
  //       }
  //     }

  //   }

  // }

  loadAssets() {
    let elementsSrc = document.querySelectorAll('[src-tmp]');

    elementsSrc.forEach((theElement: any) => {
      if (theElement.src != undefined) {
        theElement.src = theElement.getAttribute('src-tmp');
        theElement.removeAttribute('src-tmp');
      }
    });

    // $.each(, function (index, theElement) {
    //
    // });
  }

  ngOnInit(): void {
    if (this.verifyMobile()) {
      this.itsMobile = true;
    }

    AOS.init();

    this.loadAssets();

    const theTitle = 'MENA Region';
    this.title.setTitle(theTitle);

    this.seo.generateTags({
      title: theTitle,
      keyword: '',
      description: "",
      image: ''
    });

    pannellum.viewer('panoramaContainer', {
      "type": "equirectangular",
      "panorama": "./assets/img/imagineAsOne/cityscape.jpg",
      "autoLoad": true,
      "mouseZoom": false,
      "showControls": false,
      "autoRotate": 1,
      "autoRotateInactivityDelay": 3000
    });

    pannellum.viewer('panoramaContainer2', {
      "type": "equirectangular",
      "panorama": "./assets/img/imagineAsOne/studio.jpg",
      "autoLoad": true,
      "mouseZoom": false,
      "showControls": false,
      "autoRotate": 1,
      "autoRotateInactivityDelay": 3000,
      "preview": "./assets/img/imagineAsOne/studio-low.jpg"
    });

    if(localStorage.getItem('registrado') != null){
      this.sole = true;
      this.storage = true;
      setTimeout(() => {
        this.loadAssets();
      }, 1000)
    }
  }

  verifyMobile(): any {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];


    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  openVideo(number: any) {

    this["video" + number] = true;
    this.pauseAllVideos();

    setTimeout(() => {
      this.loadAssets();
      if (number == '1') {
        const video = this.el.nativeElement.querySelector('video.main-intro');
        video.play();
      }
      else if (number == '2') {
        const video = this.el.nativeElement.querySelector('video.main-video');
        video.load();
        video.play();
      }else if (number == '3') {
        const video = this.el.nativeElement.querySelector('video.main-video2');
        video.load();
        video.play();
      }else if (number == '4') {
        const video = this.el.nativeElement.querySelector('video.main-video3');
        video.load();
        video.play();
      }else if (number == '5') {
        const video = this.el.nativeElement.querySelector('video.main-video4');
        video.load();
        video.play();
      }else if (number == '6') {
        const video = this.el.nativeElement.querySelector('video.main-video5');
        video.load();
        video.play();
      }else if (number == '7') {
        const video = this.el.nativeElement.querySelector('video.main-video6');
        video.load();
        video.play();
      }else if (number == '8') {
        const video = this.el.nativeElement.querySelector('video.main-video7');
        video.play();
      }else if (number == '9') {
        const video = this.el.nativeElement.querySelector('video.main-intro2');
        video.play();
      }else if (number == '10') {
        const video = this.el.nativeElement.querySelector('video.main-video10');
      }else if (number == '11') {
        const video = this.el.nativeElement.querySelector('video.main-intro3');
        video.load();
        video.play();
      }else if (number == '12') {
        const video = this.el.nativeElement.querySelector('video.main-intro4');
        video.load();
        video.play();
      }else if (number == '13') {
        const video = this.el.nativeElement.querySelector('video.video-soledad');
        video.load();
        video.play();
      }else if (number == '14') {
        const video = this.el.nativeElement.querySelector('video.main-intro5');
        video.load();
        video.play();
      }
    }, 1000);

  }

  closeVideo(number: any) {
    this["video" + number] = false;
    if (number == '1') {
      const video = this.el.nativeElement.querySelector('video.main-intro');
      video.pause();
    }else if (number == '2') {
        const video = this.el.nativeElement.querySelector('video.main-video');
        video.pause();
    }else if (number == '3') {
      const video = this.el.nativeElement.querySelector('video.main-video2');
      video.pause();
    }else if (number == '4') {
      const video = this.el.nativeElement.querySelector('video.main-video3');
      video.pause();
    }else if (number == '5') {
      const video = this.el.nativeElement.querySelector('video.main-video4');
      video.pause();
    }else if (number == '6') {
      const video = this.el.nativeElement.querySelector('video.main-video5');
      video.pause();
    }else if (number == '7') {
      const video = this.el.nativeElement.querySelector('video.main-video6');
      video.pause();
    }else if (number == '8') {
      const video = this.el.nativeElement.querySelector('video.main-video7');
      video.pause();
    }else if (number == '9') {
      const video = this.el.nativeElement.querySelector('video.main-intro2');
      video.pause();
    }else if (number == '10') {
      const video = this.el.nativeElement.querySelector('video.main-video10');
    }else if (number == '11') {
      const video = this.el.nativeElement.querySelector('video.main-intro3');
      video.pause();
    }else if (number == '12') {
      const video = this.el.nativeElement.querySelector('video.main-intro4');
      video.pause();
    }else if (number == '13') {
      const video = this.el.nativeElement.querySelector('video.video-soledad');
      video.pause();
    }else if (number == '14') {
      const video = this.el.nativeElement.querySelector('video.main-intro5');
      video.pause();
    }
  }

  videoEnd(number: any){
    this["video" + number] = false;
    if (number == '13') {
      const video = this.el.nativeElement.querySelector('video.video-soledad');
      video.pause();
    }else if (number == '12') {
      const video = this.el.nativeElement.querySelector('video.main-intro4');
      video.pause();
    }
    else if (number == '14') {
      const video = this.el.nativeElement.querySelector('video.main-intro5');
      video.pause();
    }
  }
  pauseAllVideos(event?) {
    document.querySelectorAll('video').forEach((elem: any) => {
      if (elem) {
        try {
          elem.currentTime = 0;
          elem.load();
          elem.pause();
        } catch (error) {
        }
      }
    });
  }

  openModal(){
    this.show = true;
  }

  closeModal(){
    this.show = false;
  }

  actionVideo(number: any){
    if(number == '1'){
      this.play1 = !this.play1;
      if(this.play1 == true){
        const video = this.el.nativeElement.querySelector('video.video-mask1');
        video.play();
      }else{
        const video = this.el.nativeElement.querySelector('video.video-mask1');
        video.pause();
      }
    }else if(number == '2'){
      this.play2 = !this.play2;
      if(this.play2 == true){
        const video = this.el.nativeElement.querySelector('video.video-mask2');
        video.play();
      }else{
        const video = this.el.nativeElement.querySelector('video.video-mask2');
        video.pause();
      }
    }else if(number == '3'){
      this.play3 = !this.play3;
      if(this.play3 == true){
        const video = this.el.nativeElement.querySelector('video.video-mask3');
        video.play();
      }else{
        const video = this.el.nativeElement.querySelector('video.video-mask3');
        video.pause();
      }
    }else if(number == '4'){
      this.play4 = !this.play4;
      if(this.play4 == true){
        const video = this.el.nativeElement.querySelector('video.video-mask4');
        video.play();
      }else{
        const video = this.el.nativeElement.querySelector('video.video-mask4');
        video.pause();
      }
    }else if(number == '5'){
      this.play5 = !this.play5;
      if(this.play5 == true){
        const video = this.el.nativeElement.querySelector('video.video-mask5');
        video.play();
      }else{
        const video = this.el.nativeElement.querySelector('video.video-mask5');
        video.pause();
      }
    }else if(number == '6'){
      this.play6 = !this.play6;
      if(this.play6 == true){
        const video = this.el.nativeElement.querySelector('video.video-mask6');
        video.play();
      }else{
        const video = this.el.nativeElement.querySelector('video.video-mask6');
        video.pause();
      }
    }

  }

  pre(){
    const sectionRegister = this.el.nativeElement.querySelector('.register');
    this.register = true;
    window.scrollTo(0, sectionRegister.offsetTop - 88);
  }

  soleOne(){
    this.sole = true;
    this.pauseAllVideos();
    const sectionSole = this.el.nativeElement.querySelector('.sole-one');

    setTimeout(() => {
      this.loadAssets();
      // window.scrollTo(0, sectionSole.offsetTop - 88);

      this.openVideo('13');

      pannellum.viewer('panoramaContainer2', {
        "type": "equirectangular",
        "panorama": "./assets/img/imagineAsOne/studio.jpg",
        "autoLoad": true,
        "mouseZoom": false,
        "showControls": false,
        "autoRotate": 1,
        "autoRotateInactivityDelay": 3000,
        "preview": "./assets/img/imagineAsOne/studio-low.jpg"
      });
    }, 1000)

  }

  scrollNext(){
    const sectionWorld = this.el.nativeElement.querySelector('.next');
    window.scrollTo(0, sectionWorld.offsetTop - 62);
  }

  scrollUp(){
    const sectionSoleOne = this.el.nativeElement.querySelector('.sole-one');
    window.scrollTo(0, sectionSoleOne.offsetTop - 62);
  }

}
